<template>
    
    <div id="basic-instructions" class="basic-instructions">

        <ul class="email-browser-list" v-if="!chosenInstructions">
            <li v-for="email_client in email_clients" v-bind:key="email_client.shortname"><a href="#" v-on:click.prevent="showInstructions(email_client.shortname)"><img v-bind:src="load_aws_url + email_client.logo"><h5 v-text="email_client.name"></h5></a></li>
        </ul>
        <div class="instructions" v-if="chosenInstructions">
            <button class="btn btn-sm btn-primary go-back" v-on:click.prevent="chosenInstructions = null">Back</button>
            <div class="instructions-inside" v-html="chosenInstructions"></div>
        </div>

    </div>

</template>

<script>
    import Signature from '../mixins/Signature';
    export default {
        props: {
            load_aws_url: {
                type: String,
                default: null,
            },
            load_instruction_window: {
                type: Boolean,
                default: true,
            }
        },
        mixins: [Signature],
        data: function () {
            return {
                temp: true,
            }
        },
    }
</script>